import DataType from '@opsbase/lib-datatype/DataType';
import Pages from '@opsbase/lib-pages';
import App from '@opsbase/lib-system/App';
import { FeatureSets } from '@opsbase/lib-system/Features';
import useSelfActions from '@opsbase/react-ctrl-self/useSelfActions';
import i18n from '@opsbase/lib-i18n';
import AppPage from '@opsbase/web-app/AppPage';
import DVLPage from '@opsbase/web-dvl-page';
import React from 'react';
import StaffMenu from '../menus/StaffMenu';
import StaffSelectionToolbar from '../toolbars/StaffSelectionToolbar';
export function SetupStaffPage() {
    const { hasFeature } = useSelfActions();
    const canDeleteStaff = hasFeature(FeatureSets[App.OPSBASE].PEOPLE_MANAGEMENT_DELETION.key);
    return (React.createElement(AppPage, null,
        React.createElement(DVLPage, { viewId: DataType.STAFF, itemPage: Pages.STAFF_EDIT, itemCreatePage: Pages.STAFF_CREATE, itemMenu: StaffMenu, itemMenuExpanded: true, notFoundText: i18n.t('no-staff-found'), itemSelectionToolbar: canDeleteStaff ? React.createElement(StaffSelectionToolbar, null) : undefined })));
}
export default SetupStaffPage;
